import { render } from "./PositionManagement.vue?vue&type=template&id=0178c870"
import script from "./PositionManagement.vue?vue&type=script&lang=js"
export * from "./PositionManagement.vue?vue&type=script&lang=js"

import "./PositionManagement.vue?vue&type=style&index=0&id=0178c870&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__